<template>
  <div>
    <mdb-card class="card-image image">
      <div class="text-white text-center rgba-stylish-strong py-0 px-4">
        <div class="py-5">
          <h4 class="h4 orange-text"><mdb-icon icon="project-diagram" />  Portfolio</h4>
          <h2 class="card-title h2 my-2 py-1">Hypertech Development Projects</h2>
          <p class="mb-0 pb-0 px-md-5 mx-md-5">The following are some of the projects hypertech has undertaken successfully over the years.</p>
        </div>
      </div>
    </mdb-card>
    <div>
      <mdb-container>
        <div>
          <mdb-row>
          <mdb-col>
            <h2 class="h3 my-3">The following are some of our customers and the areas of consultancy in the last 24 months.</h2>
          </mdb-col>
        </mdb-row>
        <mdb-row class="my-1">
          <mdb-col col="sm">
            <mdb-card class="mx-1 margin-bottom">
              <img src="@/assets/tvet.jpg" alt="Site" style="object-fit: cover" height="160px" width="100%">
              <div class="container">
                <h4><b>TVET</b></h4>
                <p>Bulk SMS portal</p>
              </div>
            </mdb-card>
          </mdb-col>
          <mdb-col col="sm">
            <mdb-card class="mx-1 margin-bottom">
              <img src="@/assets/civot.jpg" alt="Site" style="object-fit: cover" height="160px" width="100%">
              <div class="container">
                <h4><b>Civotech</b></h4>
                <p>Web development</p>
              </div>
            </mdb-card>
          </mdb-col>
          <mdb-col col="sm">
            <mdb-card class="mx-1 margin-bottom">
              <img src="@/assets/kid.jpg" alt="Site" style="object-fit: cover" height="160px" width="100%">
              <div class="container">
                <h4><b>Kidivai Advocates</b></h4>
                <p>Web development</p>
              </div>
            </mdb-card>
          </mdb-col>
          <mdb-col col="sm">
            <mdb-card class="mx-1 margin-bottom">
              <img src="@/assets/krs.jpg" alt="Site" style="object-fit: cover" height="160px" width="100%">
              <div class="container">
                <h4><b>Kenya Railways Staff Retirement Benefit Scheme</b></h4>
                <p>Web Development</p>
              </div>
            </mdb-card>
          </mdb-col>
        </mdb-row>
        </div>
        <div>
        <mdb-row class="my-1">
          <mdb-col col="sm">
            <mdb-card class="mx-1 margin-bottom">
              <img src="@/assets/essay.jpg" alt="Site" style="object-fit: cover" height="160px" width="100%">
              <div class="container">
                <h4><b>Proficient Essays </b></h4>
                <p>Web Development</p>
              </div>
            </mdb-card>
          </mdb-col>
          <mdb-col col="sm">
            <mdb-card class="mx-1 margin-bottom">
              <img src="@/assets/winas2.jpg" alt="Site" style="object-fit: cover" height="160px" width="100%">
              <div class="container">
                <h4><b>Winnas Sacco Limited</b></h4>
                <p>Website Redesign</p>
              </div>
            </mdb-card>
          </mdb-col>
          <mdb-col col="sm">
            <mdb-card class="mx-1">
              <img src="@/assets/crike.jpg" alt="Site" style="object-fit: cover" height="160px" width="100%">
              <div class="container">
                <h4><b>Counselling Research Institute of Kenya</b></h4>
                <p>Web design</p>
              </div>
            </mdb-card>
          </mdb-col>
          <mdb-col col="sm">
            <mdb-card class="mx-1 margin-bottom">
              <img src="@/assets/buffalocopy.jpg" alt="Site" style="object-fit: cover" height="160px" width="100%">
              <div class="container">
                <h4><b>Kenya Film Commision</b></h4>
                <p>Intranet Design</p>
              </div>
            </mdb-card>
          </mdb-col>
        </mdb-row>
        </div>
        <div>
        <mdb-row class="my-1">
          <mdb-col col="sm">
            <mdb-card class="mx-1 margin-bottom">
              <img src="@/assets/moest.jpg" alt="Site" style="object-fit: cover" height="160px" width="100%">
              <div class="container">
                <h4><b>Ministry of Education, Science and Technology </b></h4>
                <p>Web Development & Maintenance</p>
              </div>
            </mdb-card>
          </mdb-col>
          <mdb-col col="sm">
            <mdb-card class="mx-1 margin-bottom">
              <img src="@/assets/pamtec.jpg" alt="Site" style="object-fit: cover" height="160px" width="100%">
              <div class="container">
                <h4><b>Pamtec Technologies Limited</b></h4>
                <p>Web Design & Development</p>
              </div>
            </mdb-card>
          </mdb-col>
          <mdb-col col="sm">
            <mdb-card class="mx-1 margin-bottom">
              <img src="@/assets/jr.jpg" alt="Site" style="object-fit: cover" height="160px" width="100%">
              <div class="container">
                <h4><b>Midas Junior Academy</b></h4>
                <p>Web Design</p>
              </div>
            </mdb-card>
          </mdb-col>
          <mdb-col col="sm">
            <mdb-card class="mx-1 margin-bottom">
              <img src="@/assets/roofs.jpg" alt="Site" style="object-fit: cover" height="160px" width="100%">
              <div class="container">
                <h4><b>Roofs Kenya Limited</b></h4>
                <p>Web Development</p>
              </div>
            </mdb-card>
          </mdb-col>
        </mdb-row>
        </div>
        <div>
        <mdb-row class="my-1">
          <mdb-col col="sm">
            <mdb-card class="mx-1 margin-bottom">
              <img src="@/assets/buffalo.jpg" alt="Site" style="object-fit: cover" height="160px" width="100%">
              <div class="container">
                <h4><b>Buffalo Bay Resort </b></h4>
                <p>Web Design, POS sale & Maintenance</p>
              </div>
            </mdb-card>
          </mdb-col>
          <mdb-col col="sm">
            <mdb-card class="mx-1 margin-bottom">
              <img src="@/assets/ann.png" alt="Site" style="object-fit: cover" height="160px" width="100%">
              <div class="container">
                <h4><b>Anne Mwiti Art Gallery </b></h4>
                <p>Web Development & Maintenance</p>
              </div>
            </mdb-card>
          </mdb-col>
          <mdb-col col="sm">
            <mdb-card class="mx-1 margin-bottom">
              <img src="@/assets/fleet.jpg" alt="Site" style="object-fit: cover" height="160px" width="100%">
              <div class="container">
                <h4><b>Automotive Fleet Solutions</b></h4>
                <p>Web Development & Maintenance</p>
              </div>
            </mdb-card>
          </mdb-col>
          <mdb-col col="sm">
            <mdb-card class="mx-1 margin-bottom">
              <img src="@/assets/intric8.jpg" alt="Site" style="object-fit: cover" height="160px" width="100%">
              <div class="container">
                <h4><b>Intric8 Design and Build</b></h4>
                <p>Web Design</p>
              </div>
            </mdb-card>
          </mdb-col>
        </mdb-row>
        </div>
        <div>
        <mdb-row class="my-1">
          <mdb-col col="sm">
            <mdb-card class="mx-1 margin-bottom">
              <img src="@/assets/pepper.jpg" alt="Site" style="object-fit: cover" height="160px" width="100%">
              <div class="container">
                <h4><b>Naivasha Peppercorn Holiday Resort </b></h4>
                <p>Web Development & Maintenance</p>
              </div>
            </mdb-card>
          </mdb-col>
          <mdb-col col="sm">
            <mdb-card class="mx-1 margin-bottom">
              <img src="@/assets/mmk.jpg" alt="Site" style="object-fit: cover" height="160px" width="100%">
              <div class="container">
                <h4><b>Mwaniki Kariuki and Company Advocates</b></h4>
                <p>Web Design & Hosting</p>
              </div>
            </mdb-card>
          </mdb-col>
          <mdb-col col="sm">
            <mdb-card class="mx-1 margin-bottom">
              <img src="@/assets/whm.jpg" alt="Site" style="object-fit: cover" height="160px" width="100%">
              <div class="container">
                <h4><b>World Harvest Mission</b></h4>
                <p>web development</p>
              </div>
            </mdb-card>
          </mdb-col>
        </mdb-row>
        </div>
      </mdb-container>
    </div>
  </div>
</template>

<script>
import mdbCard from 'mdbvue/lib/components/mdbCard'
import mdbIcon from 'mdbvue/lib/components/mdbIcon'
import mdbContainer from 'mdbvue/lib/components/mdbContainer'
import mdbRow from 'mdbvue/lib/components/mdbRow'
import mdbCol from 'mdbvue/lib/components/mdbCol'

export default {
  name: 'Portfolio',
  components: {
    mdbCard,
    mdbIcon,
    mdbContainer,
    mdbRow,
    mdbCol
  }
}
</script>

<style scoped>
.card {
  /* Add shadows to create the "card" effect */
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
  transition: 0.3s;
}

/* On mouse-over, add a deeper shadow */
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
}

/* Add some padding inside the card container */
.container {
  padding: 2px 16px;
}
.margin-bottom{
  margin-bottom: 50px;
}
.image {
  background: url("../assets/background2.jpeg");
}
</style>
